import * as Card from 'card';
import * as MP from './payments/mercadopago';
import * as PagSeguro from './payments/pagseguro';
import { pageLoadingOff, pageLoadingOn, validateForm } from './utilities';
import { defaultCardBrands, paymentsConfig, setCardBrands } from './payments/paymentsUtils';
import { IpagCardBrands } from './payments/ipag';

const alertPaymentUnavailable = (message, callback = null) => {
  setTimeout(() => {
    alert(message);
    if (typeof callback === 'function') callback();
  }, 500);
}

const loadAnimatedCard = (form) => {
  const formSelector = `form#${form.getAttribute('id')}`;
  const containerSelector = `div.card-wrapper.gateway${form.getAttribute('data-paymentId')}`;
  new Card({
    form: formSelector,
    container: containerSelector,
    formSelectors: {
      numberInput: formSelector+' input#cardNumber',
      expiryInput: formSelector+' input#cardExpirationDate',
      cvcInput: formSelector+' input#cardSecurityCode',
      nameInput: formSelector+' input#cardHolderName'
    },
    placeholders: {
      number: '**** **** **** ****',
      name: 'NOME IDENTIFICADOR',
      expiry: '**/**',
      cvc: '123'
    },
    width: 250,
    formatting: true,
  });

  const paymentCpfElement = document.querySelector(".form-payment-gateway-card input#personCpf");
  if (paymentCpfElement) {
    const defaultValue = document.querySelector("#checkout-user .document > span");
    if (defaultValue && defaultValue.textContent && defaultValue.textContent.length === 14) {
      paymentCpfElement.value = defaultValue.textContent;
    }
    const cpfFormatter = (e) => {
      const currentValue = e.target.value ? e.target.value.slice(0 , e.target.value.length - 1) : "";
      const currentLength = currentValue.length;
      const lastInput = e.data;
      if (!lastInput) return;
      switch (currentLength) {
        case 3: e.target.value = currentValue + "." + lastInput; break;
        case 7: e.target.value = currentValue + "." + lastInput; break;
        case 11: e.target.value = currentValue + "-" + lastInput; break;
        case 14: e.target.value = currentValue; break;
        default: e.target.value = currentValue + lastInput; break;
      }
    }
    paymentCpfElement.addEventListener("input", cpfFormatter);
  }

  document.addEventListener("card-type-changed", e => {
    const cardBrandInput = form.querySelector("input#cardBrand");
    if (cardBrandInput && e.detail !== "unknown") {
      cardBrandInput.value = e.detail;
    }
  });
}

const getGoogleRecaptchaV3Token = (form) => {
  const recaptchaInput = form.querySelector("input#googleRecaptcha");
  if (!recaptchaInput) {
    return Promise.reject("Missing recaptcha input");
  }
  const site_key = recaptchaInput.getAttribute('data-sitekey');
  const action = recaptchaInput.getAttribute('data-action');
  if (!site_key || !action) {
    return Promise.reject("Missing sitekey or data-action");
  }
  return grecaptcha.execute(site_key, { action })
    .then(token => {
      recaptchaInput.value = token;
    })
}

/**
 * 
 * @param {HTMLFormElement} form 
 * @param {(form) => Promise<void>} callback 
 */
const bindSubmitButton = (form, callback = null) => {
  form.querySelector('button#payment-submit-button').addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    pageLoadingOn();
    if (!validateForm($(form))) {
      pageLoadingOff();
      return;
    }

    if (typeof callback === "function") {
      getGoogleRecaptchaV3Token(form)
      .then(() => callback(form))
      .then(() => form.submit())
      .catch(() => {
        alertPaymentUnavailable("Não é possível finalizar o pagamento no momento", pageLoadingOff);
      });
    } else {
      getGoogleRecaptchaV3Token(form)
      .then(() => form.submit())
      .catch(() => {
        alertPaymentUnavailable("Não é possível finalizar o pagamento no momento", pageLoadingOff);
      });
    }
  });
}

export const loadCardForms = () => {
  const forms = document.querySelectorAll("form.form-payment-gateway-card");
  let cardBrands = defaultCardBrands;
  forms.forEach(form => {
    loadAnimatedCard(form);
    const gateway = form.getAttribute('data-gateway');
    switch (gateway) {
      case '20':
        MP.setInstallments(form);
        bindSubmitButton(form, MP.submitForm);
      break;

      case '25':
        paymentsConfig.loadSDKScript(25);
        bindSubmitButton(form, PagSeguro.submitForm);
      break;

      case '27':
        cardBrands = IpagCardBrands;
        bindSubmitButton(form);
      break;
    
      default: bindSubmitButton(form); break;
    }

    setCardBrands(form, cardBrands);
  });

  const mpBrick = document.querySelector("div#paymentBrick_container");
  if (mpBrick) {
    MP.renderBrick(mpBrick);
  }
}